import { $http } from './index'
export default {
  getIndexProduct (params) {
    return $http('get', '/system/BbProduct/webList', params, 0)
  },
  getIndexArticle (params) {
    return $http('get', '/system/BbArticle/webList', params, 0)
  },
  getArticleDetail (params) {
    return $http('get', '/system/BbArticle/detail', params, 0)
  },
  getProductDetail (params) {
    return $http('get', '/system/BbProduct/detail', params, 0)
  },
  saveMessage (params) {
    return $http('post', '/system/BbMess/save', params, 0)
  }
}
